import React, {useState, useEffect } from "react";
import axios from 'axios';
import {API} from '../../../common';
import EditFastenerForm from './form';

const EditFastener = (props) => {
    const [formData, setFormData] = useState([]);
    const [imagePath, setImagePath] = useState();

    console.log(setImagePath)

    useEffect(() => {
      const id = props.match.params.id;
      console.log(id)
      const ApiUrl = API+"fastenercategories/"+id;
        let axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: localStorage.getItem("token")
          }
        };
        const fetchFastener = async() => {
        await axios.get(ApiUrl,id,{axiosConfig}).then(response => response.data)
        .then((responseData)=>{
          console.log(responseData)
            setFormData(responseData.Results) ;
            setImagePath(responseData.ImgPath);
        });
      };
      fetchFastener();
    },[]);

    // console.log(imagePath)
    return (
        <>
          { formData && (
            <EditFastenerForm data={formData} imagepath={imagePath} />
            )
          }
        </>
    )
}

export default EditFastener
